import React from 'react';
import Grid from '@material-ui/core/Grid'
import {LongTextInput, required} from 'react-admin';

const ChoiceFields = props => (
    <React.Fragment>
        <Grid item xs={12} sm={6}>
            <LongTextInput style={{width: '100%'}} multiline={true} rows={10} source="text" {...props}
                           validate={required()}/>
        </Grid>

    </React.Fragment>
)

export default ChoiceFields
